import { useState } from 'react';

import styles from './dynamic-greeting.module.scss';
import { augmentClassName } from '../../../../utils/GlobalCssProxy';
import Icon from '../../../atoms/icon';
import PropTypes from 'prop-types';
import { getFormattedDynamicGreetingParameters } from './dynamic-greeting-helper';
import ModalReadMore from './dynamic-greeting-modal';
import InteractiveElement from '../../../atoms/interactive-element';
import useProfileCommonStore from '../../../../stores/profile/use-profile-common-store';

const className = augmentClassName(styles);

const DynamicGreeting = ({ participantHoldings }) => {
  const { dynamicGreetingMode, holdingsIncludingCurrentFund } = participantHoldings;
  const dynamicGreetingArr = getFormattedDynamicGreetingParameters({ dynamicGreetingMode, holdingsIncludingCurrentFund });
  const [showModal, setShowModal] = useState(false);
  const { commonState: { channel = '' } } = useProfileCommonStore();
  const isMyTiaa = channel === 'mytiaa';
  const GreetingComponent = ({ iconVariant, text, link, linkWord }) => {
    GreetingComponent.propTypes = {
      iconVariant: PropTypes.string,
      text: PropTypes.string,
      link: PropTypes.string,
      linkWord: PropTypes.string
    };
    return (
      <>
        <Icon
          variant={iconVariant}
          {...className('dynamic-greeting-icon')}
        />
        <span {...className('dynamic-greeting-text', 'dynamic-greeting')}> {text}</span>
        {
          linkWord === 'Read more.' ?
            <InteractiveElement as='span' onClick={() => setShowModal(true)} {...className('dynamic-greeting', 'dynamic-greeting-link')}>Read more.</InteractiveElement>
            :
            <a href={link} target="_blank"
              rel= "noopener noreferrer" {...className('dynamic-greeting', 'dynamic-greeting-link')}>{linkWord}</a>
        }
      </>
    );
  };
  return (
    <>
      <div {...className('dynamic-greeting-margin', isMyTiaa ? 'mytiaa-dynamic-greeting-padding' : '')}>
        {
          dynamicGreetingArr.map(data => {
            return (
              <>
                <ModalReadMore show={showModal}
                  onHide={() => setShowModal(false)} modalMessages={data.modalMessages}/>
                <GreetingComponent iconVariant={data.variant} text={data.greetingText} link={data.url} linkWord={data.linkText}/>
                <br />
              </>
            );
          })
        }

      </div>
    </>
  );
};

DynamicGreeting.propTypes = {
  participantHoldings: PropTypes.object
};

export default DynamicGreeting;
